let appInsightsConnectionString: string; 

export function configureAppInsights(settings: any){
    appInsightsConnectionString = settings.applicationInsights.connectionString;
}

export function getAppInsightsSettings() {
    return {
        appInsightsConnectionString
    }
}
